export const LANGUAGES = [
  { code: "fr", label: "Français", dir: "ltr" },
  { code: "en", label: "English", dir: "ltr" },
  { code: "tr", label: "Türkçe", dir: "ltr" },
  { code: "ar", label: "العربية", dir: "rtl" },
  { code: "ur", label: "اردو", dir: "rtl" },
  { code: "bs", label: "Bosanski", dir: "ltr" },
  { code: "ru", label: "Русский", dir: "ltr" },
  { code: "az", label: "Azərbaycanca", dir: "ltr" },
  { code: "de", label: "Deutsch", dir: "ltr" },
];

export const translations = {
  fr: {
    nav_home: "Accueil",
    nav_villas: "Les Villas",
    nav_services: "Services VIP",
    nav_vision: "La Vision",
    nav_about: "À Propos",
    nav_contact: "Contact",
    nav_language: "Langue",
    hero_eyebrow: "Golden Valley Résidences · Sarajevo",
    hero_badge: "Édition limitée — 5 villas déjà réservées",
    hero_line1: "L'Âme d'une Vallée d'Or,",
    hero_line2: "à quelques minutes de Sarajevo",
    hero_sub:
      "Un domaine privé d'exception niché dans une nature préservée. Villas ultra haut de gamme, piscines privées, air purifié — le luxe absolu, livré clé en main.",
    hero_cta: "Réserver sur WhatsApp",
    hero_cta2: "Découvrir le domaine",
    hero_scroll: "Défiler",
    marquee: [
      "Domaine sécurisé 24/7",
      "Puit privé — source pure",
      "Purificateurs d'air Natur Air",
      "Džemat — lieu de recueillement",
      "Gastronomie halal ultra-luxe",
      "Garage privatif grand luxe",
      "Fibre optique & électricité triphasée",
    ],
    gallery_eyebrow: "La Galerie",
    gallery_title: "Un écrin photographié comme une œuvre",
    gallery_sub: "Chaque villa est une pièce unique, livrée clé en main au cœur d'un écrin boisé.",
    cap1_title: "Le Domaine au crépuscule",
    cap1_sub: "Vue aérienne — résidence fermée & piscines à débordement",
    cap2_title: "Villa de maître & piscine d'azur",
    cap2_sub: "Architecture bioclimatique, garage & voiture de prestige",
    cap3_title: "Le portail d'honneur",
    cap3_sub: "Entrée privative sécurisée, allée pavée d'or",
    specs_eyebrow: "Prestations incluses",
    specs_title: "Chaque villa, un royaume autonome",
    specs_sub: "Le prix et l'acquisition se discutent en direct sur WhatsApp — en toute transparence.",
    spec_well_t: "Puit privé",
    spec_well_d: "Votre propre source d'eau pure forée sur le domaine — une autonomie totale.",
    spec_garage_t: "Garage privatif",
    spec_garage_d: "Un garage fermé pensé pour les véhicules d'exception.",
    spec_energy_t: "Électricité & Internet",
    spec_energy_d: "Réseau électrique sécurisé et internet haut débit installés dans chaque villa.",
    spec_air_t: "Air purifié Natur Air",
    spec_air_d: "Purificateurs d'air Natur Air dans chaque villa, sans exception — respirez comme pour la deuxième fois de votre vie.",
    services_eyebrow: "Conciergerie privée",
    services_title: "Le service Ultra VIP, à la carte",
    services_sub:
      "Pour un abonnement mensuel, notre équipe orchestre tout. Chaque service s'adapte à vos envies — rien d'imposé, tout est sur-mesure.",
    svc_cleaning_t: "Ménage & entretien",
    svc_cleaning_d: "Une maison impeccable, entretenue avec la discrétion des grands palaces.",
    svc_transport_t: "Transports privés",
    svc_transport_d: "Chauffeurs et transporteurs dédiés, pour chacun de vos déplacements.",
    svc_bills_t: "Paiement des factures",
    svc_bills_d: "Nous gérons vos factures et l'administratif, en toute sérénité.",
    svc_cars_t: "Voitures de luxe VIP",
    svc_cars_d: "Location de voitures de prestige, disponibles à la demande.",
    svc_security_t: "Sécurité 24/7",
    svc_security_d: "Protection rapprochée et surveillance du domaine, jour et nuit.",
    svc_more_t: "Et bien plus",
    svc_more_d: "Chef à domicile, jardinage, conciergerie… chaque service varie selon vos désirs.",
    vision_eyebrow: "La Vision",
    vision_title: "Bien plus qu'un domaine — une destination",
    vision_text:
      "GoldenValley, c'est une dizaine de villas d'exception — et bien plus encore. Demain : des hôtels et restaurants ultra-luxueux et halal, un Džemat pour la prière et le recueillement, des pelouses et des espaces entretenus à la perfection, toute l'année.",
    vision_v1: "Hôtels & restaurants halal ultra-luxueux",
    vision_v2: "Džemat — espace de prière",
    vision_v3: "Entretien complet du domaine",
    vision_v4: "D'une dizaine de villas… à bien plus",
    about_eyebrow: "À Propos de Nous",
    about_title: "Fikret Delić — Chef du projet GoldenValley",
    about_p1:
      "Dans le bâtiment depuis plus de 35 ans, Fikret Delić dirige une équipe internationale de constructeurs et cultive une expérience hors norme pour fournir le meilleur.",
    about_p2:
      "À Paris : des immeubles réalisés en six mois, clé en main — conception et décoration intérieure d'exception, notamment à la Place de l'Étoile, avec vue sur l'Arc de Triomphe. Des investissements immobiliers en France, à la tête de plusieurs villas et maisons réalisées en un temps record, avec des clients satisfaits.",
    about_p3:
      "Lui et son équipe se lancent aujourd'hui dans la construction de villas ultra haut de gamme en Bosnie : un retour aux sources, dans une vraie nature, dans ce pays magnifique au potentiel immense. GoldenValley ne s'arrêtera pas à la Bosnie — l'aventure s'étendra à tous les Balkans, du Kosovo au Monténégro.",
    about_p4:
      "Co-fondateur du groupe Natur Air, il équipe chaque villa — sans exception — de purificateurs d'air d'un niveau de filtration unique au monde. Comme si vous respiriez pour la deuxième fois de votre vie.",
    about_name: "Fikret Delić",
    about_role: "Développeur & Fondateur du projet GoldenValley",
    contact_eyebrow: "Contact direct",
    contact_title: "Parlons de votre villa, en direct",
    contact_text:
      "Prix, acquisition, visite : tout se discute directement sur WhatsApp avec le fondateur. Nous privilégions le contact direct pour une meilleure transparence et une progression plus rapide. Vidéos drone, photos et nouveautés arrivent très bientôt.",
    contact_cta: "Discuter sur WhatsApp",
    contact_note: "Réponse personnelle — +33 6 50 26 71 60",
    whatsapp_message:
      "Bonjour, je suis intéressé(e) par les villas GoldenValley près de Sarajevo. Pouvons-nous échanger ?",
    popup_label: "GoldenValley · En direct",
    popup_1: "5 villas déjà réservées sur 10 — l'édition est limitée.",
    popup_2: "Une villa vient d'être réservée par une famille internationale.",
    popup_3: "Demande de visite reçue il y a 2 minutes.",
    popup_close: "Fermer",
    footer_tagline: "L'excellence a une adresse.",
    footer_rights: "© 2026 GoldenValley — Tous droits réservés",
    footer_discretion: "Discrétion absolue · Contact WhatsApp uniquement",
    footer_founder: "Développeur & Fondateur : Fikret Delić",
  },
  en: {
    nav_home: "Home",
    nav_villas: "The Villas",
    nav_services: "VIP Services",
    nav_vision: "The Vision",
    nav_about: "About",
    nav_contact: "Contact",
    nav_language: "Langue",
    hero_eyebrow: "Golden Valley Residences · Sarajevo",
    hero_badge: "Limited edition — 5 villas already reserved",
    hero_line1: "The Soul of a Golden Valley,",
    hero_line2: "minutes away from Sarajevo",
    hero_sub:
      "A private estate of rare exception, wrapped in untouched nature. Ultra high-end villas, private pools, purified air — absolute luxury, delivered turnkey.",
    hero_cta: "Reserve on WhatsApp",
    hero_cta2: "Discover the estate",
    hero_scroll: "Scroll",
    marquee: [
      "24/7 secured estate",
      "Private well — pure spring water",
      "Natur Air purifiers",
      "Džemat — prayer & reflection",
      "Ultra-luxury halal gastronomy",
      "Prestige private garage",
      "Fiber optic & three-phase power",
    ],
    gallery_eyebrow: "The Gallery",
    gallery_title: "An estate framed like a work of art",
    gallery_sub: "Each villa is a unique piece, delivered turnkey in the heart of a wooded haven.",
    cap1_title: "The Estate at dusk",
    cap1_sub: "Aerial view — gated residence & infinity pools",
    cap2_title: "Master villa & azure pool",
    cap2_sub: "Bioclimatic architecture, garage & prestige car",
    cap3_title: "The gate of honour",
    cap3_sub: "Secure private entrance, golden paved driveway",
    specs_eyebrow: "Included with every villa",
    specs_title: "Every villa, a self-sufficient kingdom",
    specs_sub: "Price and acquisition are discussed directly on WhatsApp — in full transparency.",
    spec_well_t: "Private well",
    spec_well_d: "Your own pure spring water, drilled on the estate — total autonomy.",
    spec_garage_t: "Private garage",
    spec_garage_d: "An enclosed garage designed for exceptional vehicles.",
    spec_energy_t: "Electricity & Internet",
    spec_energy_d: "Secured power network and high-speed internet in every villa.",
    spec_air_t: "Natur Air purified air",
    spec_air_d: "Natur Air purifiers in every villa, without exception — breathe as if for the second time in your life.",
    services_eyebrow: "Private concierge",
    services_title: "Ultra VIP service, à la carte",
    services_sub:
      "For a monthly subscription, our team orchestrates everything. Each service adapts to your wishes — nothing imposed, everything tailor-made.",
    svc_cleaning_t: "Housekeeping",
    svc_cleaning_d: "An impeccable home, maintained with the discretion of grand palaces.",
    svc_transport_t: "Private transport",
    svc_transport_d: "Dedicated drivers and carriers for every journey.",
    svc_bills_t: "Bill payment",
    svc_bills_d: "We handle your bills and administration, in complete serenity.",
    svc_cars_t: "VIP luxury cars",
    svc_cars_d: "Prestige car rental, available on demand.",
    svc_security_t: "24/7 security",
    svc_security_d: "Close protection and estate surveillance, day and night.",
    svc_more_t: "And much more",
    svc_more_d: "Private chef, gardening, concierge… every service varies with your desires.",
    vision_eyebrow: "The Vision",
    vision_title: "More than an estate — a destination",
    vision_text:
      "GoldenValley is a dozen exceptional villas — and far more. Tomorrow: ultra-luxurious halal hotels and restaurants, a Džemat for prayer and reflection, lawns and grounds maintained to perfection, all year round.",
    vision_v1: "Ultra-luxury halal hotels & restaurants",
    vision_v2: "Džemat — prayer space",
    vision_v3: "Full estate maintenance",
    vision_v4: "From a dozen villas… to far more",
    about_eyebrow: "About Us",
    about_title: "Fikret Delić — Head of the GoldenValley project",
    about_p1:
      "In construction for over 35 years, Fikret Delić leads an international team of builders with an extraordinary experience to deliver the very best.",
    about_p2:
      "In Paris: buildings delivered in six months, turnkey — exceptional design and interior decoration, notably on the Place de l'Étoile, overlooking the Arc de Triomphe. Real estate investments across France, leading several villas and houses completed in record time, with satisfied clients.",
    about_p3:
      "He and his team are now building ultra high-end villas in Bosnia: a return to his roots, into true nature, in this magnificent country of immense potential. GoldenValley will not stop at Bosnia — the adventure will extend across the Balkans, from Kosovo to Montenegro.",
    about_p4:
      "Co-founder of the Natur Air group, he equips every villa — without exception — with air purifiers of a filtration level unique in the world. As if you were breathing for the second time in your life.",
    about_name: "Fikret Delić",
    about_role: "Developer & Founder of the GoldenValley project",
    contact_eyebrow: "Direct contact",
    contact_title: "Let's talk about your villa, directly",
    contact_text:
      "Price, purchase, visit: everything is discussed directly on WhatsApp with the founder. We favour direct contact for better transparency and faster progress. Drone videos, photos and news are coming very soon.",
    contact_cta: "Chat on WhatsApp",
    contact_note: "Personal reply — +33 6 50 26 71 60",
    whatsapp_message:
      "Hello, I am interested in the GoldenValley villas near Sarajevo. Can we talk?",
    popup_label: "GoldenValley · Live",
    popup_1: "5 villas already reserved out of 10 — the edition is limited.",
    popup_2: "A villa has just been reserved by an international family.",
    popup_3: "Visit request received 2 minutes ago.",
    popup_close: "Close",
    footer_tagline: "Excellence has an address.",
    footer_rights: "© 2026 GoldenValley — All rights reserved",
    footer_discretion: "Absolute discretion · WhatsApp contact only",
    footer_founder: "Developer & Founder: Fikret Delić",
  },
  tr: {
    nav_home: "Ana Sayfa",
    nav_villas: "Villalar",
    nav_services: "VIP Hizmetler",
    nav_vision: "Vizyon",
    nav_about: "Hakkımızda",
    nav_contact: "İletişim",
    nav_language: "Langue",
    hero_eyebrow: "Golden Valley Residences · Saraybosna",
    hero_badge: "Sınırlı sayıda — 5 villa şimdiden rezerve edildi",
    hero_line1: "Altın Bir Vadinin Ruhu,",
    hero_line2: "Saraybosna'ya birkaç dakika",
    hero_sub:
      "El değmemiş doğanın kalbinde, eşi benzeri olmayan özel bir mülk. Ultra lüks villalar, özel havuzlar, arındırılmış hava — anahtar teslim mutlak lüks.",
    hero_cta: "WhatsApp'tan Rezervasyon",
    hero_cta2: "Mülkü keşfedin",
    hero_scroll: "Kaydır",
    marquee: [
      "7/24 güvenlikli mülk",
      "Özel kuyu — saf kaynak suyu",
      "Natur Air hava temizleyiciler",
      "Džemat — dua ve huzur alanı",
      "Ultra lüks helal gastronomi",
      "Prestijli özel garaj",
      "Fiber optik & üç fazlı elektrik",
    ],
    gallery_eyebrow: "Galeri",
    gallery_title: "Bir sanat eseri gibi çerçevelenmiş bir mülk",
    gallery_sub: "Her villa, ağaçlarla çevrili bir cennette anahtar teslim eşsiz bir eserdir.",
    cap1_title: "Alacakaranlıkta Mülk",
    cap1_sub: "Havadan görünüm — kapalı rezidans & sonsuzluk havuzları",
    cap2_title: "Ana villa & masmavi havuz",
    cap2_sub: "Biyoklimatik mimari, garaj & prestij otomobil",
    cap3_title: "Şeref kapısı",
    cap3_sub: "Güvenli özel giriş, altın taşlı yol",
    specs_eyebrow: "Her villaya dahil",
    specs_title: "Her villa, kendi kendine yeten bir krallık",
    specs_sub: "Fiyat ve satın alma doğrudan WhatsApp'ta görüşülür — tam şeffaflıkla.",
    spec_well_t: "Özel kuyu",
    spec_well_d: "Mülk üzerinde açılmış kendi saf kaynak suyunuz — tam bağımsızlık.",
    spec_garage_t: "Özel garaj",
    spec_garage_d: "Olağanüstü araçlar için tasarlanmış kapalı garaj.",
    spec_energy_t: "Elektrik & İnternet",
    spec_energy_d: "Her villada güvenli elektrik ağı ve yüksek hızlı internet.",
    spec_air_t: "Natur Air ile arındırılmış hava",
    spec_air_d: "İstisnasız her villada Natur Air hava temizleyiciler — hayatınızda ikinci kez nefes alıyormuş gibi.",
    services_eyebrow: "Özel konsiyerj",
    services_title: "Ultra VIP hizmet, tamamen size özel",
    services_sub:
      "Aylık abonelikle ekibimiz her şeyi yönetir. Her hizmet isteklerinize göre şekillenir — hiçbir şey dayatılmaz, her şey size özeldir.",
    svc_cleaning_t: "Temizlik & bakım",
    svc_cleaning_d: "Büyük sarayların zarafetiyle, kusursuz bir ev.",
    svc_transport_t: "Özel ulaşım",
    svc_transport_d: "Her yolculuğunuz için özel şoförler ve taşıyıcılar.",
    svc_bills_t: "Fatura ödemeleri",
    svc_bills_d: "Faturalarınızı ve idari işlerinizi huzur içinde yönetiyoruz.",
    svc_cars_t: "VIP lüks araçlar",
    svc_cars_d: "Talep üzerine prestij araç kiralama.",
    svc_security_t: "7/24 güvenlik",
    svc_security_d: "Gece gündüz yakın koruma ve mülk gözetimi.",
    svc_more_t: "Ve çok daha fazlası",
    svc_more_d: "Özel şef, bahçıvanlık, konsiyerj… her hizmet arzularınıza göre değişir.",
    vision_eyebrow: "Vizyon",
    vision_title: "Bir mülkten fazlası — bir destinasyon",
    vision_text:
      "GoldenValley, on kadar olağanüstü villa demek — ve çok daha fazlası. Yarın: ultra lüks helal oteller ve restoranlar, dua ve huzur için bir Džemat, yıl boyunca kusursuz bakımlı çimler ve alanlar.",
    vision_v1: "Ultra lüks helal oteller & restoranlar",
    vision_v2: "Džemat — dua alanı",
    vision_v3: "Mülkün tam bakımı",
    vision_v4: "On villadan… çok daha ötesine",
    about_eyebrow: "Hakkımızda",
    about_title: "Fikret Delić — GoldenValley proje lideri",
    about_p1:
      "35 yılı aşkın süredir inşaat sektöründe olan Fikret Delić, uluslararası bir müteahhit ekibini yönetiyor ve en iyisini sunmak için sıra dışı bir deneyime sahip.",
    about_p2:
      "Paris'te: altı ayda anahtar teslim binalar — Zafer Takı manzaralı Étoile Meydanı'nda olağanüstü tasarım ve iç dekorasyon. Fransa genelinde gayrimenkul yatırımları, rekor sürede tamamlanan villalar ve memnun müşteriler.",
    about_p3:
      "O ve ekibi şimdi Bosna'da ultra lüks villalar inşa ediyor: köklere dönüş, gerçek doğaya, muazzam potansiyele sahip bu muhteşem ülkeye. GoldenValley Bosna'da durmayacak — macera Kosova'dan Karadağ'a tüm Balkanlar'a uzanacak.",
    about_p4:
      "Natur Air grubunun kurucu ortağı olarak, her villayı — istisnasız — dünyada eşi olmayan filtrasyon seviyesine sahip hava temizleyicilerle donatıyor. Sanki hayatınızda ikinci kez nefes alıyormuş gibi.",
    about_name: "Fikret Delić",
    about_role: "GoldenValley projesinin Geliştiricisi & Kurucusu",
    contact_eyebrow: "Doğrudan iletişim",
    contact_title: "Villanız hakkında doğrudan konuşalım",
    contact_text:
      "Fiyat, satın alma, ziyaret: her şey doğrudan kurucu ile WhatsApp'ta görüşülür. Daha iyi şeffaflık ve hızlı ilerleme için doğrudan iletişimi tercih ediyoruz. Drone videoları, fotoğraflar ve yenilikler çok yakında.",
    contact_cta: "WhatsApp'ta konuşun",
    contact_note: "Kişisel yanıt — +33 6 50 26 71 60",
    whatsapp_message:
      "Merhaba, Saraybosna yakınlarındaki GoldenValley villalarıyla ilgileniyorum. Konuşabilir miyiz?",
    popup_label: "GoldenValley · Canlı",
    popup_1: "10 villadan 5'i şimdiden rezerve edildi — sayı sınırlı.",
    popup_2: "Bir villa az önce uluslararası bir aile tarafından rezerve edildi.",
    popup_3: "2 dakika önce bir ziyaret talebi alındı.",
    popup_close: "Kapat",
    footer_tagline: "Mükemmelliğin bir adresi var.",
    footer_rights: "© 2026 GoldenValley — Tüm hakları saklıdır",
    footer_discretion: "Mutlak gizlilik · Yalnızca WhatsApp iletişimi",
    footer_founder: "Geliştirici & Kurucu: Fikret Delić",
  },
  ar: {
    nav_home: "الرئيسية",
    nav_villas: "الفلل",
    nav_services: "خدمات VIP",
    nav_vision: "الرؤية",
    nav_about: "من نحن",
    nav_contact: "اتصل بنا",
    nav_language: "Langue",
    hero_eyebrow: "غولدن فالي ريزيدنس · سراييفو",
    hero_badge: "إصدار محدود — تم حجز 5 فلل بالفعل",
    hero_line1: "روح الوادي الذهبي،",
    hero_line2: "على بُعد دقائق من سراييفو",
    hero_sub:
      "عقار خاص استثنائي في أحضان طبيعة بكر. فلل فائقة الفخامة، مسابح خاصة، هواء نقي — الرفاهية المطلقة، جاهزة للسكن.",
    hero_cta: "احجز عبر واتساب",
    hero_cta2: "اكتشف العقار",
    hero_scroll: "مرّر",
    marquee: [
      "عقار مؤمّن 24/7",
      "بئر خاص — مياه عذبة نقية",
      "أجهزة تنقية الهواء Natur Air",
      "جامع (Džemat) — مكان للصلاة والسكينة",
      "مأكولات حلال فائقة الفخامة",
      "مرآب خاص فاخر",
      "ألياف بصرية وكهرباء ثلاثية الطور",
    ],
    gallery_eyebrow: "المعرض",
    gallery_title: "عقار مؤطر كتحفة فنية",
    gallery_sub: "كل فيلا قطعة فريدة، جاهزة للسكن في قلب واحة غابات.",
    cap1_title: "العقار عند الغسق",
    cap1_sub: "منظر جوي — إقامة مسوّرة ومسابح لا متناهية",
    cap2_title: "فيلا رئيسية ومسبح أزرق",
    cap2_sub: "عمارة بيئية، مرآب وسيارة فاخرة",
    cap3_title: "بوابة الشرف",
    cap3_sub: "مدخل خاص آمن، درب مرصوف بالذهب",
    specs_eyebrow: "مشمول مع كل فيلا",
    specs_title: "كل فيلا، مملكة مكتفية ذاتياً",
    specs_sub: "السعر والشراء يُناقشان مباشرة عبر واتساب — بشفافية كاملة.",
    spec_well_t: "بئر خاص",
    spec_well_d: "مصدر مياهك النقي الخاص داخل العقار — استقلالية تامة.",
    spec_garage_t: "مرآب خاص",
    spec_garage_d: "مرآب مغلق مصمم للسيارات الاستثنائية.",
    spec_energy_t: "كهرباء وإنترنت",
    spec_energy_d: "شبكة كهرباء آمنة وإنترنت فائق السرعة في كل فيلا.",
    spec_air_t: "هواء نقي مع Natur Air",
    spec_air_d: "أجهزة تنقية Natur Air في كل فيلا دون استثناء — وكأنك تتنفس للمرة الثانية في حياتك.",
    services_eyebrow: "كونسيرج خاص",
    services_title: "خدمة VIP فائقة، حسب الطلب",
    services_sub:
      "باشتراك شهري، يدير فريقنا كل شيء. كل خدمة تتكيف مع رغباتك — لا شيء مفروض، كل شيء مصمم لك.",
    svc_cleaning_t: "التنظيف والصيانة",
    svc_cleaning_d: "منزل لا تشوبه شائبة، بعناية القصور الكبرى.",
    svc_transport_t: "النقل الخاص",
    svc_transport_d: "سائقون وناقلون مخصصون لكل تنقلاتك.",
    svc_bills_t: "دفع الفواتير",
    svc_bills_d: "نتولى فواتيرك وشؤونك الإدارية براحة تامة.",
    svc_cars_t: "سيارات فاخرة VIP",
    svc_cars_d: "تأجير سيارات فاخرة عند الطلب.",
    svc_security_t: "أمن 24/7",
    svc_security_d: "حماية شخصية ومراقبة للعقار ليلاً ونهاراً.",
    svc_more_t: "وأكثر بكثير",
    svc_more_d: "طاهٍ خاص، بستنة، كونسيرج… كل خدمة تتغير حسب رغباتك.",
    vision_eyebrow: "الرؤية",
    vision_title: "أكثر من عقار — وجهة متكاملة",
    vision_text:
      "غولدن فالي يعني نحو عشر فلل استثنائية — وأكثر بكثير. غداً: فنادق ومطاعم حلال فائقة الفخامة، وجامع (Džemat) للصلاة والسكينة، ومساحات خضراء تُصان بإتقان طوال العام.",
    vision_v1: "فنادق ومطاعم حلال فائقة الفخامة",
    vision_v2: "جامع — مساحة للصلاة",
    vision_v3: "صيانة شاملة للعقار",
    vision_v4: "من عشر فلل… إلى ما هو أبعد",
    about_eyebrow: "من نحن",
    about_title: "فكرت ديليتش — رئيس مشروع غولدن فالي",
    about_p1:
      "يعمل فكرت ديليتش في مجال البناء منذ أكثر من 35 عاماً، ويقود فريقاً دولياً من المقاولين بخبرة استثنائية لتقديم الأفضل.",
    about_p2:
      "في باريس: مبانٍ جاهزة خلال ستة أشهر — تصميم وديكور داخلي استثنائي، لا سيما في ساحة النجمة (Étoile) بإطلالة على قوس النصر. استثمارات عقارية في فرنسا، وفلل ومنازل أُنجزت في وقت قياسي مع عملاء راضين.",
    about_p3:
      "وهو وفريقه يشرعون اليوم في بناء فلل فائقة الفخامة في البوسنة: عودة إلى الجذور، إلى طبيعة حقيقية، في هذا البلد الرائع ذي الإمكانات الهائلة. لن يتوقف غولدن فالي عند البوسنة — سيمتد المشروع عبر البلقان، من كوسوفو إلى الجبل الأسود.",
    about_p4:
      "بصفته الشريك المؤسس لمجموعة Natur Air، يجهّز كل فيلا — دون استثناء — بأجهزة تنقية هواء بمستوى ترشيح فريد في العالم. وكأنك تتنفس للمرة الثانية في حياتك.",
    about_name: "فكرت ديليتش",
    about_role: "مطوّر ومؤسس مشروع غولدن فالي",
    contact_eyebrow: "تواصل مباشر",
    contact_title: "لنتحدث عن فيلتك مباشرة",
    contact_text:
      "السعر والشراء والزيارة: كل شيء يُناقش مباشرة عبر واتساب مع المؤسس. نفضّل التواصل المباشر لشفافية أكبر وتقدم أسرع. فيديوهات بطائرة درون وصور جديدة قريباً جداً.",
    contact_cta: "تحدث عبر واتساب",
    contact_note: "رد شخصي — +33 6 50 26 71 60",
    whatsapp_message:
      "مرحباً، أنا مهتم بفلل غولدن فالي بالقرب من سراييفو. هل يمكننا التحدث؟",
    popup_label: "غولدن فالي · مباشر",
    popup_1: "تم حجز 5 فلل من أصل 10 — الإصدار محدود.",
    popup_2: "تم حجز فيلا للتو من قبل عائلة دولية.",
    popup_3: "تم استلام طلب زيارة قبل دقيقتين.",
    popup_close: "إغلاق",
    footer_tagline: "للتميّز عنوان.",
    footer_rights: "© 2026 غولدن فالي — جميع الحقوق محفوظة",
    footer_discretion: "خصوصية مطلقة · التواصل عبر واتساب فقط",
    footer_founder: "المطوّر والمؤسس: فكرت ديليتش",
  },
  ur: {
    nav_home: "ہوم",
    nav_villas: "ولاز",
    nav_services: "VIP خدمات",
    nav_vision: "ویژن",
    nav_about: "ہمارے بارے میں",
    nav_contact: "رابطہ",
    nav_language: "Langue",
    hero_eyebrow: "گولڈن ویلی ریزیڈنسز · سرائیوو",
    hero_badge: "محدود ایڈیشن — 5 ولاز پہلے ہی بک ہو چکے",
    hero_line1: "سنہری وادی کی روح،",
    hero_line2: "سرائیوو سے چند منٹ کی دوری پر",
    hero_sub:
      "قدرتی حسن کی گود میں ایک نادر پرائیویٹ اسٹیٹ۔ انتہائی پُرتعیش ولاز، نجی پول، صاف ہوا — مطلق عیش و عشرت، مکمل تیار۔",
    hero_cta: "واٹس ایپ پر بک کریں",
    hero_cta2: "اسٹیٹ دریافت کریں",
    hero_scroll: "سکرول",
    marquee: [
      "24/7 محفوظ اسٹیٹ",
      "نجی کنواں — صاف چشمے کا پانی",
      "Natur Air ایئر پیوریفائر",
      "جامع (Džemat) — نماز و سکون کی جگہ",
      "انتہائی پُرتعیش حلال کھانے",
      "پریسٹیج نجی گیراج",
      "فائبر آپٹک اور تھری فیز بجلی",
    ],
    gallery_eyebrow: "گیلری",
    gallery_title: "فن پارے کی طرح سجا ایک اسٹیٹ",
    gallery_sub: "ہر ولا ایک منفرد شاہکار، درختوں کی آغوش میں مکمل تیار۔",
    cap1_title: "شام کے وقت اسٹیٹ",
    cap1_sub: "فضائی منظر — باڑ والا رہائشی کمپلیکس اور انفنٹی پول",
    cap2_title: "ماسٹر ولا اور نیلا پول",
    cap2_sub: "بایوکلائمیٹک آرکیٹیکچر، گیراج اور پریسٹیج کار",
    cap3_title: "شاندار داخلی دروازہ",
    cap3_sub: "محفوظ نجی داخلہ، سنہری سنگ فرش راستہ",
    specs_eyebrow: "ہر ولا کے ساتھ شامل",
    specs_title: "ہر ولا، ایک خود کفیل سلطنت",
    specs_sub: "قیمت اور خریداری براہ راست واٹس ایپ پر طے ہوگی — مکمل شفافیت کے ساتھ۔",
    spec_well_t: "نجی کنواں",
    spec_well_d: "اسٹیٹ پر آپ کا اپنا صاف پانی — مکمل خود کفالت۔",
    spec_garage_t: "نجی گیراج",
    spec_garage_d: "غیر معمولی گاڑیوں کے لیے بند گیراج۔",
    spec_energy_t: "بجلی اور انٹرنیٹ",
    spec_energy_d: "ہر ولا میں محفوظ بجلی کا نظام اور ہائی سپیڈ انٹرنیٹ۔",
    spec_air_t: "Natur Air صاف ہوا",
    spec_air_d: "ہر ولا میں بلا استثنا Natur Air پیوریفائر — گویا زندگی میں دوسری بار سانس لے رہے ہوں۔",
    services_eyebrow: "نجی کنسیرج",
    services_title: "الٹرا VIP سروس، آپ کی مرضی سے",
    services_sub:
      "ماہانہ فیس کے عوض ہماری ٹیم سب کچھ سنبھالتی ہے۔ ہر سروس آپ کی خواہش کے مطابق — کچھ بھی لازم نہیں، سب کچھ آپ کے لیے۔",
    svc_cleaning_t: "صفائی اور دیکھ بھال",
    svc_cleaning_d: "شاندار محلوں جیسی نزاکت سے بے عیب گھر۔",
    svc_transport_t: "نجی ٹرانسپورٹ",
    svc_transport_d: "ہر سفر کے لیے مخصوص ڈرائیور اور ٹرانسپورٹر۔",
    svc_bills_t: "بلوں کی ادائیگی",
    svc_bills_d: "ہم آپ کے بل اور انتظامی معاملات پورے سکون سے سنبھالتے ہیں۔",
    svc_cars_t: "VIP لگژری کاریں",
    svc_cars_d: "طلب پر پریسٹیج کار کرایہ پر۔",
    svc_security_t: "24/7 سیکیورٹی",
    svc_security_d: "دن رات ذاتی تحفظ اور اسٹیٹ کی نگرانی۔",
    svc_more_t: "اور بھی بہت کچھ",
    svc_more_d: "نجی شیف، باغبانی، کنسیرج… ہر سروس آپ کی مرضی کے مطابق۔",
    vision_eyebrow: "ویژن",
    vision_title: "صرف ایک اسٹیٹ نہیں — ایک منزل",
    vision_text:
      "گولڈن ویلی کا مطلب ہے تقریباً دس غیر معمولی ولاز — اور اس سے کہیں زیادہ۔ کل: انتہائی پُرتعیش حلال ہوٹل اور ریستوران، نماز و سکون کے لیے جامع (Džemat)، اور سال بھر مثالی دیکھ بھال والے میدان۔",
    vision_v1: "انتہائی پُرتعیش حلال ہوٹل اور ریستوران",
    vision_v2: "جامع — نماز کی جگہ",
    vision_v3: "اسٹیٹ کی مکمل دیکھ بھال",
    vision_v4: "دس ولاز سے… اس سے کہیں آگے",
    about_eyebrow: "ہمارے بارے میں",
    about_title: "فکرت دیلچ — گولڈن ویلی پروجیکٹ کے سربراہ",
    about_p1:
      "فکرت دیلچ 35 سال سے زیادہ عرصے سے تعمیرات کے شعبے میں ہیں اور بین الاقوامی تعمیراتی ٹیم کی قیادت کرتے ہیں — بہترین فراہم کرنے کے لیے غیر معمولی تجربہ۔",
    about_p2:
      "پیرس میں: چھ ماہ میں مکمل عمارتیں — آرک ڈی ٹریومف کے منظر کے ساتھ Étoile چوک پر غیر معمولی ڈیزائن اور اندرونی سجاوٹ۔ فرانس بھر میں پراپٹی سرمایہ کاری، ریکارڈ وقت میں مکمل ولاز اور مطمئن کلائنٹس۔",
    about_p3:
      "وہ اور ان کی ٹیم اب بوسنیا میں انتہائی پُرتعیش ولاز بنا رہے ہیں: جڑوں کی طرف واپسی، حقیقی قدرت میں، اس شاندار ملک میں جس کی صلاحیتیں بے پایاں ہیں۔ گولڈن ویلی بوسنیا پر نہیں رکے گا — یہ سفر کوسووہ سے مونٹینیگرو تک پورے بالکان میں پھیلے گا۔",
    about_p4:
      "Natur Air گروپ کے شریک بانی کے طور پر، وہ ہر ولا کو — بلا استثنا — دنیا میں منفرد فلٹریشن لیول کے ایئر پیوریفائر سے لیس کرتے ہیں۔ گویا آپ زندگی میں دوسری بار سانس لے رہے ہوں۔",
    about_name: "فکرت دیلچ",
    about_role: "گولڈن ویلی پروجیکٹ کے ڈویلپر اور بانی",
    contact_eyebrow: "براہ راست رابطہ",
    contact_title: "آئیے اپنے ولا کے بارے میں براہ راست بات کریں",
    contact_text:
      "قیمت، خریداری، وزٹ: سب کچھ بانی کے ساتھ براہ راست واٹس ایپ پر۔ ہم بہتر شفافیت اور تیز پیش رفت کے لیے براہ راست رابطہ ترجیح دیتے ہیں۔ ڈرون ویڈیوز، تصاویر اور نئی خبریں بہت جلد۔",
    contact_cta: "واٹس ایپ پر بات کریں",
    contact_note: "ذاتی جواب — +33 6 50 26 71 60",
    whatsapp_message:
      "السلام علیکم، مجھے سرائیوو کے قریب گولڈن ویلی ولاز میں دلچسپی ہے۔ کیا ہم بات کر سکتے ہیں؟",
    popup_label: "گولڈن ویلی · براہ راست",
    popup_1: "10 میں سے 5 ولاز پہلے ہی بک — ایڈیشن محدود ہے۔",
    popup_2: "ایک بین الاقوامی خاندان نے ابھی ایک ولا بک کیا۔",
    popup_3: "2 منٹ پہلے وزٹ کی درخواست موصول ہوئی۔",
    popup_close: "بند کریں",
    footer_tagline: "عمدگی کا ایک پتہ ہے۔",
    footer_rights: "© 2026 گولڈن ویلی — جملہ حقوق محفوظ ہیں",
    footer_discretion: "مکمل رازداری · صرف واٹس ایپ رابطہ",
    footer_founder: "ڈویلپر اور بانی: فکرت دیلچ",
  },
  bs: {
    nav_home: "Početna",
    nav_villas: "Vile",
    nav_services: "VIP Usluge",
    nav_vision: "Vizija",
    nav_about: "O Nama",
    nav_contact: "Kontakt",
    nav_language: "Langue",
    hero_eyebrow: "Golden Valley Residences · Sarajevo",
    hero_badge: "Ograničena edicija — 5 vila je već rezervisano",
    hero_line1: "Duša Zlatne Doline,",
    hero_line2: "samo nekoliko minuta od Sarajeva",
    hero_sub:
      "Privatno imanje rijetke izuzetnosti, smješteno u netaknutoj prirodi. Ultra luksuzne vile, privatni bazeni, pročišćen zrak — apsolutni luksuz, ključ u ruke.",
    hero_cta: "Rezervišite putem WhatsAppa",
    hero_cta2: "Otkrijte imanje",
    hero_scroll: "Skrolaj",
    marquee: [
      "Osigurano imanje 24/7",
      "Privatni bunar — čista izvorska voda",
      "Natur Air prečistači zraka",
      "Džemat — mjesto za molitvu i mir",
      "Ultra luksuzna halal gastronomija",
      "Prestižna privatna garaža",
      "Optički internet i trofazna struja",
    ],
    gallery_eyebrow: "Galerija",
    gallery_title: "Imanje uokvireno poput umjetničkog djela",
    gallery_sub: "Svaka vila je jedinstveno djelo, ključ u ruke, u srcu šumskog raja.",
    cap1_title: "Imanje u sumrak",
    cap1_sub: "Pogled iz zraka — ograđeno naselje i infinity bazeni",
    cap2_title: "Glavna vila i azurni bazen",
    cap2_sub: "Bioklimatska arhitektura, garaža i prestižni automobil",
    cap3_title: "Počasna kapija",
    cap3_sub: "Siguran privatni ulaz, zlatna popločana aleja",
    specs_eyebrow: "Uključeno u svaku vilu",
    specs_title: "Svaka vila, samodovoljno kraljevstvo",
    specs_sub: "Cijena i kupovina se dogovaraju direktno putem WhatsAppa — u potpunoj transparentnosti.",
    spec_well_t: "Privatni bunar",
    spec_well_d: "Vaš vlastiti izvor čiste vode na imanju — potpuna nezavisnost.",
    spec_garage_t: "Privatna garaža",
    spec_garage_d: "Zatvorena garaža dizajnirana za izuzetna vozila.",
    spec_energy_t: "Struja i internet",
    spec_energy_d: "Sigurna električna mreža i brzi internet u svakoj vili.",
    spec_air_t: "Pročišćen zrak Natur Air",
    spec_air_d: "Natur Air prečistači zraka u svakoj vili, bez izuzetka — dišite kao da dišete drugi put u životu.",
    services_eyebrow: "Privatna concierge služba",
    services_title: "Ultra VIP usluga, po mjeri",
    services_sub:
      "Uz mjesečnu pretplatu, naš tim organizuje sve. Svaka usluga se prilagođava vašim željama — ništa nametnuto, sve po mjeri.",
    svc_cleaning_t: "Čišćenje i održavanje",
    svc_cleaning_d: "Besprijekoran dom, održavan s diskrecijom velikih palača.",
    svc_transport_t: "Privatni prijevoz",
    svc_transport_d: "Namjenski vozači i prevoznici za svako vaše putovanje.",
    svc_bills_t: "Plaćanje računa",
    svc_bills_d: "Mi upravljamo vašim računima i administracijom, u potpunoj sigurnosti.",
    svc_cars_t: "VIP luksuzna vozila",
    svc_cars_d: "Iznajmljivanje prestižnih automobila, dostupno na zahtjev.",
    svc_security_t: "Sigurnost 24/7",
    svc_security_d: "Lična zaštita i nadzor imanja, dan i noć.",
    svc_more_t: "I mnogo više",
    svc_more_d: "Privatni kuhar, vrtlarstvo, concierge… svaka usluga varira prema vašim željama.",
    vision_eyebrow: "Vizija",
    vision_title: "Više od imanja — destinacija",
    vision_text:
      "GoldenValley je desetak izuzetnih vila — i mnogo više od toga. Sutra: ultra luksuzni halal hoteli i restorani, džemat za molitvu i duhovni mir, travnjaci i prostori održavani do savršenstva, tokom cijele godine.",
    vision_v1: "Ultra luksuzni halal hoteli i restorani",
    vision_v2: "Džemat — prostor za molitvu",
    vision_v3: "Potpuno održavanje imanja",
    vision_v4: "Od desetak vila… do mnogo više",
    about_eyebrow: "O Nama",
    about_title: "Fikret Delić — Šef projekta GoldenValley",
    about_p1:
      "U građevinarstvu više od 35 godina, Fikret Delić vodi međunarodni tim graditelja s izvanrednim iskustvom kako bi pružio najbolje.",
    about_p2:
      "U Parizu: zgrade završene za šest mjeseci, ključ u ruke — izuzetan dizajn i uređenje interijera, posebno na Trgu Étoile, s pogledom na Slavoluk pobjede. Investicije u nekretnine u Francuskoj, na čelu nekoliko vila i kuća završenih u rekordnom vremenu, sa zadovoljnim klijentima.",
    about_p3:
      "On i njegov tim sada grade ultra luksuzne vile u Bosni: povratak korijenima, u pravu prirodu, u ovu prekrasnu zemlju ogromnog potencijala. GoldenValley se neće zaustaviti u Bosni — avantura će se proširiti na cijeli Balkan, od Kosova do Crne Gore.",
    about_p4:
      "Kao suosnivač grupe Natur Air, svaku vilu oprema — bez izuzetka — prečistačima zraka s nivoom filtracije jedinstvenim u svijetu. Kao da dišete po drugi put u životu.",
    about_name: "Fikret Delić",
    about_role: "Developer i osnivač projekta GoldenValley",
    contact_eyebrow: "Direktan kontakt",
    contact_title: "Razgovarajmo o vašoj vili, direktno",
    contact_text:
      "Cijena, kupovina, posjeta: sve se dogovara direktno putem WhatsAppa s osnivačem. Preferiramo direktan kontakt radi bolje transparentnosti i bržeg napretka. Dronski snimci, fotografije i novosti stižu vrlo uskoro.",
    contact_cta: "Razgovarajte putem WhatsAppa",
    contact_note: "Lični odgovor — +33 6 50 26 71 60",
    whatsapp_message:
      "Dobar dan, zainteresovan/a sam za vile GoldenValley u blizini Sarajeva. Možemo li razgovarati?",
    popup_label: "GoldenValley · Uživo",
    popup_1: "5 vila je već rezervisano od 10 — edicija je ograničena.",
    popup_2: "Vilu je upravo rezervisala međunarodna porodica.",
    popup_3: "Zahtjev za posjetu primljen prije 2 minute.",
    popup_close: "Zatvori",
    footer_tagline: "Izvrsnost ima adresu.",
    footer_rights: "© 2026 GoldenValley — Sva prava zadržana",
    footer_discretion: "Apsolutna diskrecija · Kontakt samo putem WhatsAppa",
    footer_founder: "Developer i osnivač: Fikret Delić",
  },
  ru: {
    nav_home: "Главная",
    nav_villas: "Виллы",
    nav_services: "VIP-услуги",
    nav_vision: "Видение",
    nav_about: "О нас",
    nav_contact: "Контакт",
    nav_language: "Langue",
    hero_eyebrow: "Golden Valley Residences · Сараево",
    hero_badge: "Ограниченная серия — 5 вилл уже забронированы",
    hero_line1: "Душа Золотой Долины,",
    hero_line2: "в нескольких минутах от Сараево",
    hero_sub:
      "Частное имение редкой исключительности в объятиях нетронутой природы. Виллы ультра-класса, частные бассейны, очищенный воздух — абсолютная роскошь под ключ.",
    hero_cta: "Забронировать в WhatsApp",
    hero_cta2: "Откройте имение",
    hero_scroll: "Листайте",
    marquee: [
      "Охраняемое имение 24/7",
      "Собственная скважина — чистая родниковая вода",
      "Очистители воздуха Natur Air",
      "Джемат — место для молитвы и покоя",
      "Халяльная гастрономия ультра-люкс",
      "Престижный частный гараж",
      "Оптоволокно и трёхфазная сеть",
    ],
    gallery_eyebrow: "Галерея",
    gallery_title: "Имение, обрамлённое как произведение искусства",
    gallery_sub: "Каждая вилла — уникальное произведение, готовое под ключ, в сердце лесного рая.",
    cap1_title: "Имение в сумерках",
    cap1_sub: "Вид с воздуха — закрытая резиденция и панорамные бассейны",
    cap2_title: "Главная вилла и лазурный бассейн",
    cap2_sub: "Биоклиматическая архитектура, гараж и престижный автомобиль",
    cap3_title: "Парадные ворота",
    cap3_sub: "Защищённый частный вход, золотая мостовая",
    specs_eyebrow: "Включено в каждую виллу",
    specs_title: "Каждая вилла — самодостаточное королевство",
    specs_sub: "Цена и приобретение обсуждаются напрямую в WhatsApp — в полной прозрачности.",
    spec_well_t: "Собственная скважина",
    spec_well_d: "Ваш собственный источник чистой воды на территории — полная автономность.",
    spec_garage_t: "Частный гараж",
    spec_garage_d: "Закрытый гараж, созданный для исключительных автомобилей.",
    spec_energy_t: "Электричество и интернет",
    spec_energy_d: "Защищённая электросеть и высокоскоростной интернет в каждой вилле.",
    spec_air_t: "Очищенный воздух Natur Air",
    spec_air_d: "Очистители воздуха Natur Air в каждой вилле без исключения — словно вы дышите во второй раз в жизни.",
    services_eyebrow: "Частный консьерж",
    services_title: "Ультра VIP-сервис, полностью по вашему желанию",
    services_sub:
      "За ежемесячную абонентскую плату наша команда организует всё. Каждая услуга подстраивается под ваши желания — ничего навязанного, всё по мерке.",
    svc_cleaning_t: "Уборка и обслуживание",
    svc_cleaning_d: "Безупречный дом, содержащийся со сдержанностью великих дворцов.",
    svc_transport_t: "Частный транспорт",
    svc_transport_d: "Персональные водители и перевозчики для каждой поездки.",
    svc_bills_t: "Оплата счетов",
    svc_bills_d: "Мы берём на себя ваши счета и административные вопросы — в полном спокойствии.",
    svc_cars_t: "VIP автомобили класса люкс",
    svc_cars_d: "Аренда престижных автомобилей по запросу.",
    svc_security_t: "Охрана 24/7",
    svc_security_d: "Личная охрана и наблюдение за имением днём и ночью.",
    svc_more_t: "И многое другое",
    svc_more_d: "Личный шеф-повар, садоводство, консьерж… каждая услуга меняется по вашему желанию.",
    vision_eyebrow: "Видение",
    vision_title: "Больше, чем имение — направление",
    vision_text:
      "GoldenValley — это около десятка исключительных вилл и гораздо больше. Завтра: ультра-роскошные халяльные отели и рестораны, джемат для молитвы и духовного покоя, лужайки и территории, поддерживаемые в совершенстве круглый год.",
    vision_v1: "Ультра-роскошные халяльные отели и рестораны",
    vision_v2: "Джемат — место для молитвы",
    vision_v3: "Полное обслуживание имения",
    vision_v4: "От десятка вилл… к гораздо большему",
    about_eyebrow: "О нас",
    about_title: "Фикрет Делич — руководитель проекта GoldenValley",
    about_p1:
      "Более 35 лет в строительстве: Фикрет Делич руководит международной командой строителей с выдающимся опытом, чтобы предлагать самое лучшее.",
    about_p2:
      "В Париже: здания, сданные за шесть месяцев под ключ — исключительный дизайн и внутренняя отделка, в том числе на площади Этуаль с видом на Триумфальную арку. Инвестиции в недвижимость во Франции, несколько вилл и домов, построенных в рекордные сроки, с довольными клиентами.",
    about_p3:
      "Он и его команда теперь строят ультра-роскошные виллы в Боснии: возвращение к истокам, в настоящую природу, в эту великолепную страну с огромным потенциалом. GoldenValley не остановится на Боснии — приключение распространится на все Балканы, от Косово до Черногории.",
    about_p4:
      "Как сооснователь группы Natur Air, он оснащает каждую виллу — без исключения — очистителями воздуха с уникальным в мире уровнем фильтрации. Словно вы дышите во второй раз в жизни.",
    about_name: "Фикрет Делич",
    about_role: "Разработчик и основатель проекта GoldenValley",
    contact_eyebrow: "Прямой контакт",
    contact_title: "Поговорим о вашей вилле напрямую",
    contact_text:
      "Цена, покупка, визит: всё обсуждается напрямую в WhatsApp с основателем. Мы предпочитаем прямой контакт ради большей прозрачности и быстрого прогресса. Видео с дрона, фотографии и новости — уже совсем скоро.",
    contact_cta: "Написать в WhatsApp",
    contact_note: "Личный ответ — +33 6 50 26 71 60",
    whatsapp_message:
      "Здравствуйте, меня интересуют виллы GoldenValley рядом с Сараево. Можем ли мы поговорить?",
    popup_label: "GoldenValley · Напрямую",
    popup_1: "5 вилл из 10 уже забронированы — серия ограничена.",
    popup_2: "Вилла только что забронирована международной семьёй.",
    popup_3: "Запрос на посещение получен 2 минуты назад.",
    popup_close: "Закрыть",
    footer_tagline: "У совершенства есть адрес.",
    footer_rights: "© 2026 GoldenValley — Все права защищены",
    footer_discretion: "Абсолютная конфиденциальность · Контакт только через WhatsApp",
    footer_founder: "Разработчик и основатель: Фикрет Делич",
  },
  az: {
    nav_home: "Ana səhifə",
    nav_villas: "Villalar",
    nav_services: "VIP Xidmətlər",
    nav_vision: "Vizyon",
    nav_about: "Haqqımızda",
    nav_contact: "Əlaqə",
    nav_language: "Langue",
    hero_eyebrow: "Golden Valley Residences · Sarayevo",
    hero_badge: "Məhdud buraxılış — 5 villa artıq rezerv edilib",
    hero_line1: "Qızıl Vadinin Ruhu,",
    hero_line2: "Sarayevodan cəmi bir neçə dəqiqəlik",
    hero_sub:
      "Əl dəyməmiş təbiətin qoynunda nadir, istisna xüsusi mülk. Ultra lüks villalar, özəl hovuzlar, təmizlənmiş hava — açar təhvil mütləq lüks.",
    hero_cta: "WhatsApp ilə rezerv edin",
    hero_cta2: "Mülkü kəşf edin",
    hero_scroll: "Sürüşdür",
    marquee: [
      "24/7 qorunan mülk",
      "Özəl quyu — saf bulaq suyu",
      "Natur Air hava təmizləyiciləri",
      "Camaat (Džemat) — dua və sakitlik yeri",
      "Ultra lüks halal qastronomiya",
      "Prestijli özəl qaraj",
      "Fiber optik və üçfazlı elektrik",
    ],
    gallery_eyebrow: "Qalereya",
    gallery_title: "İncəsənət əsəri kimi çərçivələnmiş mülk",
    gallery_sub: "Hər villa meşəlik cənnətin mərkəzində açar təhvil unikal əsərdir.",
    cap1_title: "Toran vaxtı mülk",
    cap1_sub: "Havadan görünüş — qapalı rezidensiya və sonsuzluq hovuzları",
    cap2_title: "Əsas villa və mavi hovuz",
    cap2_sub: "Bioklimatik arxitektura, qaraj və prestij avtomobili",
    cap3_title: "Şərəf qapısı",
    cap3_sub: "Təhlükəsiz özəl giriş, qızıl daşlı yol",
    specs_eyebrow: "Hər villaya daxildir",
    specs_title: "Hər villa, özünəkafil bir krallıqdır",
    specs_sub: "Qiymət və alış birbaşa WhatsApp-da müzakirə olunur — tam şəffaflıqla.",
    spec_well_t: "Özəl quyu",
    spec_well_d: "Mülkdə qazılmış öz saf bulaq suyunuz — tam müstəqillik.",
    spec_garage_t: "Özəl qaraj",
    spec_garage_d: "İstisnai avtomobillər üçün nəzərdə tutulmuş qapalı qaraj.",
    spec_energy_t: "Elektrik və İnternet",
    spec_energy_d: "Hər villada təhlükəsiz elektrik şəbəkəsi və yüksək sürətli internet.",
    spec_air_t: "Natur Air ilə təmizlənmiş hava",
    spec_air_d: "İstisnasız hər villada Natur Air hava təmizləyiciləri — sanki ömrünüzdə ikinci dəfə nəfəs alırsınız.",
    services_eyebrow: "Özəl konsyerj",
    services_title: "Ultra VIP xidmət, tamamilə sizə uyğun",
    services_sub:
      "Aylıq abunə ilə komandamız hər şeyi idarə edir. Hər xidmət istəklərinizə uyğunlaşır — heç nə tətbiq olunmur, hər şey sizə xüsusidir.",
    svc_cleaning_t: "Təmizlik və qulluq",
    svc_cleaning_d: "Böyük sarayların zərifliyi ilə qüsursuz bir ev.",
    svc_transport_t: "Özəl nəqliyyat",
    svc_transport_d: "Hər səfəriniz üçün xüsusi sürücülər və daşıyıcılar.",
    svc_bills_t: "Faktura ödənişləri",
    svc_bills_d: "Fakturalarınızı və inzibati işlərinizi tam rahatlıqla idarə edirik.",
    svc_cars_t: "VIP lüks avtomobillər",
    svc_cars_d: "Tələb üzrə prestij avtomobil icarəsi.",
    svc_security_t: "24/7 təhlükəsizlik",
    svc_security_d: "Gecə-gündüz yaxın mühafizə və mülk nəzarəti.",
    svc_more_t: "Və daha çox",
    svc_more_d: "Özəl aşpaz, bağbanlıq, konsyerj… hər xidmət arzularınıza görə dəyişir.",
    vision_eyebrow: "Vizyon",
    vision_title: "Bir mülkdən çox — bir istiqamət",
    vision_text:
      "GoldenValley təxminən on istisna villa deməkdir — və bundan çox daha çox. Sabah: ultra lüks halal hotellər və restoranlar, dua və sakitlik üçün bir Camaat (Džemat), il boyu qüsursuz qulluq görmüş çəmənliklər və sahələr.",
    vision_v1: "Ultra lüks halal hotellər və restoranlar",
    vision_v2: "Camaat — dua məkanı",
    vision_v3: "Mülkün tam qulluğu",
    vision_v4: "On villadan… daha uzağa",
    about_eyebrow: "Haqqımızda",
    about_title: "Fikret Delić — GoldenValley layihəsinin rəhbəri",
    about_p1:
      "35 ildən çoxdur tikinti sahəsində olan Fikret Delić beynəlxalq tikinti komandasına rəhbərlik edir və ən yaxşısını təqdim etmək üçün qeyri-adi təcrübəyə malikdir.",
    about_p2:
      "Paridə: altı ayda açar təhvil binalar — Zəfər Tağına baxan Étoile meydanında istisna dizayn və daxili dekorasiya. Fransa üzrə daşınmaz əmlak investisiyaları, rekord müddətdə tamamlanmış villalar və məmnun müştərilər.",
    about_p3:
      "O və komandası indi Bosniyada ultra lüks villalar tikir: köklərə qayıdış, həqiqi təbiətə, böyük potensiala malik bu möhtəşəm ölkəyə. GoldenValley Bosniyada dayanmayacaq — macəra Kosovodan Monteneqroya qədər bütün Balkanlara yayılacaq.",
    about_p4:
      "Natur Air qrupunun həmtəsisçisi olaraq, hər villanı — istisnasız — dünyada unikal filtrasiya səviyyəsinə malik hava təmizləyiciləri ilə təchiz edir. Sanki ömrünüzdə ikinci dəfə nəfəs alırsınız.",
    about_name: "Fikret Delić",
    about_role: "GoldenValley layihəsinin Tərtibatçısı və Təsisçisi",
    contact_eyebrow: "Birbaşa əlaqə",
    contact_title: "Villanız haqqında birbaşa danışaq",
    contact_text:
      "Qiymət, alış, ziyarət: hər şey təsisçi ilə birbaşa WhatsApp-da müzakirə olunur. Daha yaxşı şəffaflıq və sürətli irəliləyiş üçün birbaşa əlaqəni üstün tuturuq. Dron videoları, fotolar və yeniliklər çox tezliklə.",
    contact_cta: "WhatsApp-da danışın",
    contact_note: "Şəxsi cavab — +33 6 50 26 71 60",
    whatsapp_message:
      "Salam, Sarayevo yaxınlığındakı GoldenValley villaları ilə maraqlanıram. Danışa bilərikmi?",
    popup_label: "GoldenValley · Canlı",
    popup_1: "10 villadan 5-i artıq rezerv edilib — say məhduddur.",
    popup_2: "Bir villa bu dəqiqə beynəlxalq ailə tərəfindən rezerv edildi.",
    popup_3: "2 dəqiqə əvvəl ziyarət sorğusu qəbul edildi.",
    popup_close: "Bağla",
    footer_tagline: "Mükəmməlliyin bir ünvanı var.",
    footer_rights: "© 2026 GoldenValley — Bütün hüquqlar qorunur",
    footer_discretion: "Mütləq məxfilik · Yalnız WhatsApp əlaqəsi",
    footer_founder: "Tərtibatçı və Təsisçi: Fikret Delić",
  },
  de: {
    nav_home: "Startseite",
    nav_villas: "Die Villen",
    nav_services: "VIP-Services",
    nav_vision: "Die Vision",
    nav_about: "Über Uns",
    nav_contact: "Kontakt",
    nav_language: "Langue",
    hero_eyebrow: "Golden Valley Residences · Sarajevo",
    hero_badge: "Limitierte Edition — 5 Villen bereits reserviert",
    hero_line1: "Die Seele eines Goldenen Tals,",
    hero_line2: "wenige Minuten von Sarajevo entfernt",
    hero_sub:
      "Ein privates Anwesen von seltener Ausnahme, eingebettet in unberührte Natur. Ultra-hochwertige Villen, private Pools, gereinigte Luft — absoluter Luxus, schlüsselfertig übergeben.",
    hero_cta: "Per WhatsApp reservieren",
    hero_cta2: "Das Anwesen entdecken",
    hero_scroll: "Scrollen",
    marquee: [
      "24/7 gesichertes Anwesen",
      "Privater Brunnen — reines Quellwasser",
      "Natur Air Luftreiniger",
      "Džemat — Ort des Gebets und der Besinnung",
      "Halal-Gastronomie der Extraklasse",
      "Prestigevolle private Garage",
      "Glasfaser & Drehstrom",
    ],
    gallery_eyebrow: "Die Galerie",
    gallery_title: "Ein Anwesen, gerahmt wie ein Kunstwerk",
    gallery_sub: "Jede Villa ist ein einzigartiges Stück, schlüsselfertig im Herzen eines Waldparadieses.",
    cap1_title: "Das Anwesen in der Dämmerung",
    cap1_sub: "Luftaufnahme — geschlossene Residenz & Infinity-Pools",
    cap2_title: "Herrschaftsvilla & azurblauer Pool",
    cap2_sub: "Bioklimatische Architektur, Garage & Prestigefahrzeug",
    cap3_title: "Das Ehrentor",
    cap3_sub: "Gesicherter privater Eingang, goldene gepflasterte Allee",
    specs_eyebrow: "In jeder Villa enthalten",
    specs_title: "Jede Villa, ein autarkes Königreich",
    specs_sub: "Preis und Erwerb werden direkt per WhatsApp besprochen — in voller Transparenz.",
    spec_well_t: "Privater Brunnen",
    spec_well_d: "Ihre eigene reine Wasserquelle auf dem Anwesen — vollkommene Autarkie.",
    spec_garage_t: "Private Garage",
    spec_garage_d: "Eine geschlossene Garage, konzipiert für außergewöhnliche Fahrzeuge.",
    spec_energy_t: "Strom & Internet",
    spec_energy_d: "Gesichertes Stromnetz und Highspeed-Internet in jeder Villa.",
    spec_air_t: "Gereinigte Luft mit Natur Air",
    spec_air_d: "Natur Air Luftreiniger in jeder Villa, ohne Ausnahme — atmen Sie, als würden Sie zum zweiten Mal in Ihrem Leben atmen.",
    services_eyebrow: "Privater Concierge",
    services_title: "Ultra-VIP-Service, ganz nach Ihren Wünschen",
    services_sub:
      "Gegen ein monatliches Abonnement orchestriert unser Team alles. Jeder Service passt sich Ihren Wünschen an — nichts wird aufgedrängt, alles ist maßgeschneidert.",
    svc_cleaning_t: "Reinigung & Pflege",
    svc_cleaning_d: "Ein makelloses Zuhause, gepflegt mit der Diskretion großer Paläste.",
    svc_transport_t: "Privater Transport",
    svc_transport_d: "Dedizierte Fahrer und Transporteure für jede Ihrer Fahrten.",
    svc_bills_t: "Rechnungszahlung",
    svc_bills_d: "Wir kümmern uns um Ihre Rechnungen und Verwaltung — in völliger Gelassenheit.",
    svc_cars_t: "VIP-Luxusautos",
    svc_cars_d: "Vermietung von Prestigefahrzeugen, auf Anfrage verfügbar.",
    svc_security_t: "Sicherheit 24/7",
    svc_security_d: "Personenschutz und Überwachung des Anwesens, Tag und Nacht.",
    svc_more_t: "Und vieles mehr",
    svc_more_d: "Privatkoch, Gartenpflege, Concierge… jeder Service richtet sich nach Ihren Wünschen.",
    vision_eyebrow: "Die Vision",
    vision_title: "Mehr als ein Anwesen — eine Destination",
    vision_text:
      "GoldenValley bedeutet ein Dutzend außergewöhnlicher Villen — und weitaus mehr. Morgen: ultra-luxuriöse Halal-Hotels und -Restaurants, ein Džemat für Gebet und Besinnung, Rasenflächen und Anlagen, das ganze Jahr perfekt gepflegt.",
    vision_v1: "Ultra-luxuriöse Halal-Hotels & -Restaurants",
    vision_v2: "Džemat — Gebetsraum",
    vision_v3: "Komplette Pflege des Anwesens",
    vision_v4: "Von einem Dutzend Villen… zu weitaus mehr",
    about_eyebrow: "Über Uns",
    about_title: "Fikret Delić — Leiter des GoldenValley-Projekts",
    about_p1:
      "Seit über 35 Jahren im Bauwesen tätig, leitet Fikret Delić ein internationales Team von Bauunternehmern mit außergewöhnlicher Erfahrung, um stets das Beste zu liefern.",
    about_p2:
      "In Paris: Gebäude in sechs Monaten schlüsselfertig realisiert — außergewöhnliche Konzeption und Inneneinrichtung, insbesondere an der Place de l'Étoile mit Blick auf den Arc de Triomphe. Immobilieninvestitionen in Frankreich, mehrere Villen und Häuser in Rekordzeit fertiggestellt, mit zufriedenen Kunden.",
    about_p3:
      "Er und sein Team bauen nun ultra-hochwertige Villen in Bosnien: eine Rückkehr zu den Wurzeln, in wahre Natur, in dieses wunderschöne Land mit immensem Potenzial. GoldenValley wird nicht in Bosnien haltmachen — das Abenteuer erstreckt sich über den gesamten Balkan, vom Kosovo bis Montenegro.",
    about_p4:
      "Als Mitbegründer der Natur Air Gruppe rüstet er jede Villa — ohne Ausnahme — mit Luftreinigern aus, deren Filtrationsniveau weltweit einzigartig ist. Als würden Sie zum zweiten Mal in Ihrem Leben atmen.",
    about_name: "Fikret Delić",
    about_role: "Entwickler & Gründer des GoldenValley-Projekts",
    contact_eyebrow: "Direkter Kontakt",
    contact_title: "Sprechen wir direkt über Ihre Villa",
    contact_text:
      "Preis, Erwerb, Besichtigung: alles wird direkt per WhatsApp mit dem Gründer besprochen. Wir bevorzugen den direkten Kontakt für mehr Transparenz und schnelleren Fortschritt. Drohnenvideos, Fotos und Neuigkeiten folgen in Kürze.",
    contact_cta: "Auf WhatsApp schreiben",
    contact_note: "Persönliche Antwort — +33 6 50 26 71 60",
    whatsapp_message:
      "Guten Tag, ich interessiere mich für die GoldenValley-Villen bei Sarajevo. Können wir sprechen?",
    popup_label: "GoldenValley · Live",
    popup_1: "5 von 10 Villen bereits reserviert — die Edition ist limitiert.",
    popup_2: "Eine Villa wurde soeben von einer internationalen Familie reserviert.",
    popup_3: "Besichtigungsanfrage vor 2 Minuten erhalten.",
    popup_close: "Schließen",
    footer_tagline: "Exzellenz hat eine Adresse.",
    footer_rights: "© 2026 GoldenValley — Alle Rechte vorbehalten",
    footer_discretion: "Absolute Diskretion · Kontakt nur per WhatsApp",
    footer_founder: "Entwickler & Gründer: Fikret Delić",
  },
};

export const WHATSAPP_NUMBER = "33650267160";
export const whatsappLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
